export default function permission ({ next, store, to }) {
  const requiredPermission = to.meta.permission

  if (!requiredPermission) {
    return next()
  }

  const userPermissions = store.getters['Auth/getPermissions'] || []
  const isAdmin = store.getters['Auth/isAdmin'] || false

  if (userPermissions.includes(requiredPermission) || isAdmin) {
    return next()
  }

  return next({
    name: 'unauthorized',
    query: { permission: requiredPermission }
  })
}
